import ModalProvider from './ModalProvider'
import { useModalContext } from './ModalProvider'

export { useModalContext }
export default ModalProvider
